'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _transport = require('../../transport/transport.xhr');

var _transport2 = _interopRequireDefault(_transport);

var _sync = require('./sync.constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _operationalCacheStorage = {},
    _cacheExpireTimers = {};

var _runningXHR = {};

var operationalCache = {
    get: function get(key) {
        return _operationalCacheStorage[key] || null;
    },
    set: function set(key, data) {
        if (key) {
            _operationalCacheStorage[key] = data;
        }

        return _operationalCacheStorage[key] || null;
    },
    remove: function remove(key) {
        delete _operationalCacheStorage[key];
    }
};

var defaultOptions = {
    cacheLiveTime: 60000
};

var _class = function () {
    function _class() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, _class);

        this.options = Object.assign({}, defaultOptions, options);
        this.protocol = options.protocol;
        this.url = options.url;

        this.Transport = options.transport || _transport2.default;

        return this;
    }

    _createClass(_class, [{
        key: 'post',
        value: function post(options) {
            return this.query(options, 'post');
        }
    }, {
        key: 'put',
        value: function put(options) {
            return this.query(options, 'put');
        }
    }, {
        key: 'delete',
        value: function _delete(options) {
            return this.query(options, 'delete');
        }
    }, {
        key: 'get',
        value: function get(options) {
            return this.query(options, 'get');
        }
    }, {
        key: 'query',
        value: function query() {
            var _this = this;

            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
            var queryId = void 0,
                queryOptions = Object.assign({}, this.options, options),
                _queryOptions$data = queryOptions.data,
                data = _queryOptions$data === undefined ? {} : _queryOptions$data;


            queryId = this.getQueryId(queryOptions);

            // force unique query ID
            if (queryOptions.force) {
                queryId += new Date().getTime();
            }

            // рандом параметр для IOS 6+, который кеширует пост запросы
            if (method && method.toLowerCase() === 'post') {
                if (data instanceof FormData) {
                    data.append('_', new Date().getTime());
                } else if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
                    data._ = new Date().getTime();
                }
            }

            // наличие кеша
            var cachedData = this._getCache(queryId, queryOptions);

            if (cachedData) {
                try {
                    return this._success(queryOptions, cachedData).then(function (packet) {
                        return Promise.resolve(packet && packet.data);
                    });
                } catch (e) {
                    return Promise.reject('Sync XHR. Cannot resolve data from query cache.');
                }
            }

            if (queryOptions.contentType === 'application/json') {
                data = JSON.stringify(data);
                // alias for migration from jquery to axios
                queryOptions.headers = queryOptions.headers || {};
                queryOptions.headers['Content-Type'] = queryOptions.contentType;
            }

            if (queryOptions.dataType) {
                // alias for migration from jquery to axios
                queryOptions.responseType = queryOptions.dataType;
            }

            if (!_runningXHR[queryId]) {
                var transport = new this.Transport(queryOptions.url || this.url, queryOptions),
                    xhrCall = void 0;

                if (typeof transport[method] !== 'function') {
                    return Promise.reject('Sync XHR. Transport method ' + method + ' not found.');
                }

                _runningXHR[queryId] = new Promise(function (resolve, reject) {
                    if (method === 'get') {
                        xhrCall = transport[method](queryOptions);
                    } else {
                        xhrCall = transport[method](data, queryOptions);
                    }

                    xhrCall.then(function (response) {
                        if (queryOptions.cacheResponse) {
                            _this._cache(queryId, queryOptions, response.data || {});
                        }

                        return _this._success(queryOptions, response.data || {});
                    }, function (error) {
                        return _this._error(queryOptions, error);
                    }).then(function (packet) {
                        resolve(packet && packet.data);
                        delete _runningXHR[queryId];
                    }, function (packet) {
                        reject(packet);
                        delete _runningXHR[queryId];
                    });
                });
            }

            return _runningXHR[queryId];
        }
    }, {
        key: '_success',
        value: function _success(queryOptions, data) {
            var packet = void 0;

            // parse response by protocol rules
            if (typeof queryOptions.protocol === 'function') {
                packet = this._parseProtocol(data, queryOptions.protocol);
            } else if (this.protocol) {
                packet = this._parseProtocol(data, this.protocol);
            } else {
                packet = {
                    status: _sync.responseState.SUCCESS,
                    data: data
                };
            }

            // response is invalid by protocol rules
            if (packet.status === _sync.responseState.ERROR) {
                return Promise.reject(packet);
            } else if (packet.status === _sync.responseState.SUCCESS) {
                return Promise.resolve(packet);
            }
        }
    }, {
        key: '_error',
        value: function _error(queryOptions) {
            var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var packet = void 0,
                response = error.response || {};

            // server sent valid error response
            if (response && response.data) {
                // parse response by protocol rules
                if (typeof queryOptions.protocol === 'function') {
                    packet = this._parseProtocol(response.data, queryOptions.protocol);
                } else if (this.protocol) {
                    packet = this._parseProtocol(response.data, this.protocol);
                } else {
                    packet = {
                        status: response.status || _sync.responseState.ERROR,
                        message: response.data.message || response.message || response.statusText
                    };
                }
            } else if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object') {
                packet = Object.assign({}, response, {
                    message: error.message || response.statusText
                });
            } else {
                packet = {
                    status: _sync.responseState.ERROR,
                    message: error.message
                };
            }

            return Promise.reject(packet);
        }
    }, {
        key: '_parseProtocol',
        value: function _parseProtocol(response, protocol) {
            if (typeof protocol === 'function') {
                return protocol(response);
            } else {
                return {};
            }
        }
    }, {
        key: '_cache',
        value: function _cache(key, querySettings, data) {
            var _querySettings$cacheO = querySettings.cacheOptions,
                cacheOptions = _querySettings$cacheO === undefined ? {} : _querySettings$cacheO,
                cacheStorage = void 0,
                dataString = void 0;


            cacheStorage = cacheOptions.storage || operationalCache;

            // deep copy for save original response
            try {
                dataString = JSON.stringify(data);
            } catch (e) {
                dataString = '';
            }

            if (typeof cacheStorage.set === 'function') {
                cacheStorage.set(key, dataString);

                clearTimeout(_cacheExpireTimers[key]);

                _cacheExpireTimers[key] = setTimeout(function () {
                    cacheStorage.remove(key);
                }, cacheOptions.time || this.options.cacheLiveTime);
            }

            return this;
        }
    }, {
        key: '_getCache',
        value: function _getCache(key, querySettings) {
            var _querySettings$cacheO2 = querySettings.cacheOptions,
                cacheOptions = _querySettings$cacheO2 === undefined ? {} : _querySettings$cacheO2,
                cacheStorage = void 0,
                result = null;


            cacheStorage = cacheOptions.storage || operationalCache;

            if (typeof cacheStorage.get === 'function') {
                result = cacheStorage.get(key);

                try {
                    result = JSON.parse(result);
                } catch (e) {
                    result = null;
                }
            }

            return result;
        }
    }, {
        key: 'getQueryId',
        value: function getQueryId() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return options.cacheOptions && options.cacheOptions.id || options.url + JSON.stringify(options.data || {});
        }
    }]);

    return _class;
}();

exports.default = _class;